import React, { useState, useEffect } from 'react';
import './App.css';

function Reloj() {
  const [empleados, setEmpleados] = useState([]);
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState('');
  const [historial, setHistorial] = useState([]);

  // --- ESTADOS PARA LOS FILTROS ---
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [filtroEmpleado, setFiltroEmpleado] = useState(''); // Ahora es para la lista desplegable

  useEffect(() => {
    fetchEmpleados();
    fetchHistorial();
  }, []);

  const fetchEmpleados = async () => {
    try {
      const res = await fetch('/api/empleados');
      const data = await res.json();
      setEmpleados(data);
    } catch (error) {
      console.error('Error cargando empleados:', error);
    }
  };

  const fetchHistorial = async () => {
    try {
      const res = await fetch('/api/fichajes');
      const data = await res.json();
      setHistorial(data);
    } catch (error) {
      console.error('Error cargando historial:', error);
    }
  };

  const registrarFichaje = async (tipo) => {
    if (!empleadoSeleccionado) {
      alert('⚠️ Por favor, seleccione su nombre de la lista primero.');
      return;
    }

    try {
      const res = await fetch('/api/fichajes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ empleado_id: empleadoSeleccionado, tipo_fichaje: tipo })
      });

      if (res.ok) {
        alert(`¡Fichaje de "${tipo}" registrado con éxito!`);
        fetchHistorial();
      } else {
        alert('Error al registrar el fichaje. Intente de nuevo.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const formatearFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleString('es-UY'); 
  };

  // --- MOTOR DE FILTRADO EN TIEMPO REAL ---
  // 1. Verificamos si el usuario ha seleccionado al menos un filtro
  const hayFiltroActivo = fechaInicio !== '' || fechaFin !== '' || filtroEmpleado !== '';

  const historialFiltrado = historial.filter(registro => {
    let cumpleFecha = true;
    const fechaRegistro = new Date(registro.fecha_hora);

    if (fechaInicio) {
      const inicio = new Date(fechaInicio);
      inicio.setHours(0, 0, 0, 0);
      if (fechaRegistro < inicio) cumpleFecha = false;
    }
    if (fechaFin) {
      const fin = new Date(fechaFin);
      fin.setHours(23, 59, 59, 999);
      if (fechaRegistro > fin) cumpleFecha = false;
    }

    let cumpleEmpleado = true;
    if (filtroEmpleado) {
      // Ahora la comparación es exacta porque viene de una lista predefinida
      cumpleEmpleado = registro.nombre === filtroEmpleado;
    }

    return cumpleFecha && cumpleEmpleado;
  });

  return (
    <div className="dashboard-pantalla">
      <header className="dashboard-header">
        <img src="/logo.png" alt="ASPE Logo" className="dashboard-logo" />
        <button onClick={() => window.location.href = '/dashboard'} className="btn-volver">Volver al Panel</button>
      </header>

      <main className="dashboard-main">
        <h2>⏱️ Reloj de Fichaje</h2>
        <p>Seleccione su nombre en la lista y registre su horario operativo.</p>
        
        <div className="reloj-container">
          <div className="reloj-panel">
            <h3>Terminal de Asistencia</h3>
            <select className="reloj-select" value={empleadoSeleccionado} onChange={(e) => setEmpleadoSeleccionado(e.target.value)}>
              <option value="">-- Busque y seleccione su nombre --</option>
              {empleados.map(emp => (
                <option key={emp.id} value={emp.id}>{emp.nombre} ({emp.cargo || 'Sin cargo'})</option>
              ))}
            </select>

            <div className="reloj-botones">
              <button onClick={() => registrarFichaje('Entrada')} className="btn-fichaje btn-entrada">🟢 Entrada</button>
              <button onClick={() => registrarFichaje('Inicio Descanso')} className="btn-fichaje btn-descanso">☕ Inicio Descanso</button>
              <button onClick={() => registrarFichaje('Fin Descanso')} className="btn-fichaje btn-descanso-fin">▶️ Fin Descanso</button>
              <button onClick={() => registrarFichaje('Salida')} className="btn-fichaje btn-salida">🔴 Salida</button>
            </div>
          </div>

          <div className="reloj-historial">
            <h3>Buscador de Registros</h3>
            
            {/* --- BARRA DE FILTROS --- */}
            <div className="filtros-bar">
              <div className="filtro-grupo">
                <label>Desde:</label>
                <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
              </div>
              <div className="filtro-grupo">
                <label>Hasta:</label>
                <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
              </div>
              <div className="filtro-grupo filtro-texto-grupo">
                <label>Filtrar por Empleado:</label>
                {/* Reemplazamos el input de texto por un select dinámico */}
                <select value={filtroEmpleado} onChange={(e) => setFiltroEmpleado(e.target.value)} className="reloj-select" style={{border: '1px solid #ccc', fontWeight: 'normal'}}>
                  <option value="">-- Todos los empleados --</option>
                  {empleados.map(emp => (
                    <option key={emp.id} value={emp.nombre}>{emp.nombre} ({emp.cargo})</option>
                  ))}
                </select>
              </div>
            </div>

            <table className="tabla-aspe">
              <thead>
                <tr>
                  <th>Empleado</th>
                  <th>Actividad</th>
                  <th>Hora Exacta</th>
                </tr>
              </thead>
              <tbody>
                {/* Lógica: Si no hay filtro, mostramos mensaje. Si hay filtro, mostramos resultados. */}
                {!hayFiltroActivo ? (
                  <tr>
                    <td colSpan="3" style={{textAlign: 'center', padding: '30px', color: '#666', fontStyle: 'italic'}}>
                      🔍 Utilice los filtros de arriba (Fecha o Empleado) para visualizar el historial de fichajes.
                    </td>
                  </tr>
                ) : historialFiltrado.length > 0 ? (
                  historialFiltrado.map(registro => (
                    <tr key={registro.id}>
                      <td>
                        <strong>{registro.nombre}</strong><br/>
                        <small style={{color: '#666'}}>{registro.cargo} | {registro.rol}</small>
                      </td>
                      <td>
                        <span className={`badge-fichaje badge-${registro.tipo_fichaje.replace(' ', '-')}`}>
                          {registro.tipo_fichaje}
                        </span>
                      </td>
                      <td>{formatearFecha(registro.fecha_hora)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{textAlign: 'center', padding: '20px', color: '#dc3545', fontWeight: 'bold'}}>
                      No se encontraron registros para los filtros seleccionados.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Reloj;